import type { IValidateAddressParams } from "./types"

export const addressKeys = {
  all: ["address"] as const,
  details: () => [...addressKeys.all, "detail"] as const,
  detail: (address_guid: string | undefined) =>
    [...addressKeys.details(), address_guid] as const,
  autocompletedAddress: (address_lookup: string | undefined) =>
    [...addressKeys.details(), "autocompletedAddress", address_lookup] as const,
  validatedAddress: (address_params: IValidateAddressParams | undefined) =>
    [...addressKeys.details(), "validatedAddress", address_params] as const,
}
